var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.1667H15.8333C16.2754 14.1667 16.6993 13.9911 17.0118 13.6785C17.3244 13.366 17.5 12.942 17.5 12.5V9.16667C17.5 8.72464 17.3244 8.30072 17.0118 7.98816C16.6993 7.6756 16.2754 7.5 15.8333 7.5L4.16667 7.5C3.72464 7.5 3.30072 7.6756 2.98816 7.98816C2.67559 8.30072 2.5 8.72464 2.5 9.16667L2.5 12.5C2.5 12.942 2.67559 13.366 2.98816 13.6785C3.30072 13.9911 3.72464 14.1667 4.16667 14.1667H5.83333",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 7.5V4.16667C14.1673 3.72464 13.9917 3.30072 13.6792 2.98816C13.3666 2.67559 12.9427 2.5 12.5007 2.5L7.50065 2.5C7.05862 2.5 6.6347 2.67559 6.32214 2.98816C6.00958 3.30072 5.83398 3.72464 5.83398 4.16667L5.83398 7.5",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 12.5026C5.83398 12.0606 6.00958 11.6367 6.32214 11.3241C6.6347 11.0115 7.05862 10.8359 7.50065 10.8359L12.5007 10.8359C12.9427 10.8359 13.3666 11.0115 13.6792 11.3241C13.9917 11.6367 14.1673 12.0606 14.1673 12.5026V15.8359C14.1673 16.278 13.9917 16.7019 13.6792 17.0144C13.3666 17.327 12.9427 17.5026 12.5007 17.5026H7.50065C7.05862 17.5026 6.6347 17.327 6.32214 17.0144C6.00958 16.7019 5.83398 16.278 5.83398 15.8359L5.83398 12.5026Z",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPrinter);
export default __webpack_public_path__ + "static/media/svg_printer.57827135becbe3ae734eabe414026f57.svg";
export { ForwardRef as ReactComponent };